import React, { useEffect, useRef, useState } from 'react'
import getCssVariable from '../../App/validation/getCssVariable';
import Modal from '../common_modal/Modal';
import useLanguage from '../common_hooks/useLanguage';
import { ArrowBack, CheckCircle } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { send_otp_email, validate_otp_email } from '../../App/actions/authActions';
import is_valid_email from "../../App/validation/is_valid_email";


function EditEmail({ placeholder }) {
  const user = useSelector(state => state.auth.user)
  const value = user.email;

  const dispatch = useDispatch();

  const [oldEmail, setOldEmail] = useState("");
  const initialized = useRef(false);

  const [email, setEmail] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [page, setPage] = useState("editor"); // editor atau otp
  const [code, setCode] = useState(["", "", "", "", "", ""])
  const [isModalOpen, setIsModalOpen] = useState(false);

  const is_old_email_verified = user.is_email_confirm === "success"
  const is_same_email = value === email;

  const { dict, language } = useLanguage()

  useEffect(() => {
    if (initialized.current) return;
    setEmail(user.email);
    setIsVerified(is_old_email_verified)
    initialized.current = true;

  }, [is_old_email_verified, user?.email])

  useEffect(() => {
    setOldEmail(value)
  }, [value]) // hanya jalankan sekali saat komponen dimount


  const toggle_modal = () => {
    setIsModalOpen(!isModalOpen)
    setPage("editor");
  }

  const emailOnChange = (e) => {
    const newEmail = e.target.value
    setEmail(newEmail);
    setIsVerified(false);
  };

  const send_otp = () => {
    if (email) {
      dispatch(send_otp_email({ email }));
      setPage("otp")
    }
  }

  const handleChange = (value, index) => {
    if (isNaN(value)) return; // hanya menerima angka
    const newOtp = [...code];
    newOtp[index] = value;
    setCode(newOtp)

    // otomatis pindah ke input berikutnya jika terisi
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && code[index] === "" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handleSubmitCode = async () => {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const otp_code = code?.join("");
    const body = { otp: otp_code, language, email };
    const res = await dispatch(validate_otp_email(body));
    if (res.status === 200) toggle_modal();

  };

  const bg = getCssVariable("--base")

  const change_email_number_content = (
    <>
      <header>
        <label className="bold font_30">
          {dict["Change Email"][language]}
        </label>
        <div className="flex">
          <hr
            style={{
              height: "2px",
              width: "50%",
              backgroundColor: "black",
              border: "1px solid black",
            }}
          />
          <hr
            style={{
              height: "2px",
              width: "50%",
              backgroundColor: "black",
              border: "1px solid black",
            }}
          />
        </div>
      </header>

      <section className="flex flex_col gap_10 margin_10">
        <p>{dict["Enter your email correctly"][language]}</p>
        <div className="flex align_center gap_10">
          <input
            placeholder={"E-Mail"}
            type="text"
            name="email"
            id="email"
            value={email}
            onChange={(e) => emailOnChange(e)}
            className="input_new"
            style={{ borderBottom: "2px solid black" }}
          />
          {(isVerified || is_same_email) && !!email && <CheckCircle fontSize='small' />}
        </div>
        {!is_valid_email(email) && <label style={{ color: "red" }}>{dict["Invalid email"][language]}</label>}
        <button
          id="resend"
          className={`border h_40 rounded_5 ${!(isVerified || is_same_email) && is_valid_email(email) ? "bg_black" : "bg_grey cursor_default"} text_white marginTop_20`}
          onClick={() => { if (!(isVerified || is_same_email) && is_valid_email(email)) send_otp() }}
        >
          {dict["Send OTP"][language]}
        </button>
      </section>
    </>
  );

  const verify_otp_content = <>
    <div className='flex marginBottom_10' style={{ alignItems: "center" }}>
      <button
        onClick={() => setPage("editor")}
        className='rounded_full center_perfect padding_5 bg_black text_white marginRight_10'
      >
        <ArrowBack />
      </button>
      <h2>OTP Verification</h2>
    </div>
    <p>{dict["We have sent the security code to"][language]}</p>

    <h1>{email}</h1>

    <div className="otp-inputs">
      {code.map((value, index) => (
        <input
          key={index}
          id={`otp-input-${index}`}
          type="text"
          maxLength="1"
          value={value}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className="otp-input"
        />
      ))}
    </div>

    <div className="w_full h_50 center_perfect margin_y_30">
      <button
        id="resend"
        className="border h_40 rounded_5 bg_black text_white marginTop_20 w_full"
        onClick={() => handleSubmitCode()}
      >
        {dict["Verify OTP & save email"][language]}
      </button>
    </div>
    <div>
      <p className="text_grey">
        {dict["Didn't receive the code?"][language]}{" "}
        <span
          className="bold pointer"
          style={{ color: "black" }}
          onClick={() => send_otp()}
        >
          {dict["Resend"][language]}
        </span>{" "}
      </p>
    </div>
  </>

  let modal_change_number_content = null;
  if (page === "editor") {
    modal_change_number_content = change_email_number_content;
  } else if (page === "otp") {
    modal_change_number_content = verify_otp_content;
  }

  const modalChangeNumber = isModalOpen && <Modal
    modalSize="small"
    id="modal"
    isOpen={isModalOpen}
    onClose={() => toggle_modal()}
  >
    {modal_change_number_content}
  </Modal>


  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}>
      <label style={{
        fontWeight: 600
      }}>{placeholder}</label>
      <div
        style={{
          height: '50px',
          backgroundColor: bg,
          width: "100%",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer"
        }}
        onClick={() => toggle_modal()}
      >
        <div
          style={{
            padding: '5px 0 5px 0',
            marginLeft: "15px",
            display: "flex",
            gap: "5px"
          }}
        >
          <div>{oldEmail}</div>
          {is_old_email_verified && <CheckCircle fontSize='small' />}
        </div>
      </div>

      {modalChangeNumber}
    </div>

  )
}

export default EditEmail